// extracted by mini-css-extract-plugin
export default {"list":"MainNavigation_list__HE0yo","aLink":"MainNavigation_aLink__lufaJ"};